<template>
    <ExceptionDetailsModal
        :coverage-type-label="coverageTypeLabel"
        :criterion-label="criterionLabel"
        :override-type-label="overrideTypeLabel"
        :expiration-date="expirationDate"
        :note="note"
        :granted-by="grantedBy"
        :date="date"
        @close="$emit('abort')"
    />
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import ExceptionDetailsModal from '@/modules/entity-details/components/ExceptionDetailsModal/ExceptionDetailsModal.vue';

    // PRODUCT-26110 QA fixes4: declares the `abort` event this procedure component
    // `$emit`s -- without a declared `emits`, Vue 3 warns "Component emitted event
    // 'abort' but it is neither declared in the emits option nor as an 'onAbort' prop"
    // every time it fires.
    export default defineComponent({
        name: 'ViewExceptionProcedure',
        components: { ExceptionDetailsModal },
        // PRODUCT-26110 QA fixes4: `uuid` is unused; declared purely so Vue 3 doesn't warn
        // "Extraneous non-props attributes (uuid)" (see UploadEntityDocumentProcedure.vue).
        props: {
            uuid: {
                type: String,
                default: '',
            },
            coverageTypeLabel: {
                type: String as PropType<string>,
                default: '',
            },
            criterionLabel: {
                type: String as PropType<string>,
                default: '',
            },
            overrideTypeLabel: {
                type: String as PropType<string>,
                default: '',
            },
            expirationDate: {
                type: String as PropType<string>,
                default: '',
            },
            note: {
                type: String as PropType<string | null>,
                default: null,
            },
            grantedBy: {
                type: String as PropType<string>,
                default: '',
            },
            date: {
                type: String as PropType<string>,
                default: '',
            },
        },
        emits: [ 'abort' ],
    });
</script>
